export const MAIN_PAGE_PATH = '/';
export const UPLOAD_PAGE_PATH = '/upload-file';
export const REVIEW_ENTRIES_PATH = '/review-entries';
export const HEADER_SELECTION_PATH = '/select-header';
export const MATCH_COLUMN_PATH = '/match-column';
export const SHEET_SELECTION_PATH = '/select-sheet';
